module.exports = __webpack_public_path__ + "assets/img/cloudgo_logo.4e810730.png";